import $ from 'jquery';

const initScrollTo = (el) => {
    const $el = $(el);
    const href = $el.attr('href');
    const dataHref = $el.data('href');
    const dataOffset = $el.data('offset');
    const scrollTo = href !== undefined && href !== '' ? href : (
        dataHref !== undefined && dataHref !== '' ? dataHref : ''
    );
    const offset = dataOffset !== undefined && dataOffset !== '' ? dataOffset : 0;

    $el.click(function scrollToElClick(e) {
        e.preventDefault();
        triggerScrollTo(scrollTo, offset);
        
        if($el.hasClass('js-report-nav-item')) {
            $('.js-report-nav-item').removeClass('js-report-nav-item-active');
            $el.addClass('js-report-nav-item-active');
        }
    });
};

const triggerScrollTo = (scrollTo = '', offset = 0) => {
    const $target = $(scrollTo);
    $('html, body').animate({ scrollTop: $target.position().top + offset }, 'slow');
};

export default initScrollTo;
export const scrollTo = triggerScrollTo;
